import {StorageEnum} from 'src/app/models/storage.enum';

export const appAuthCleanUpItems: StorageEnum[] = [];
